export class ClaimTypes {
  static readonly NAME = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name';
  static readonly EMAIL = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress';
  static readonly NAME_IDENTIFIER = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier';
  static readonly FIRST_NAME = 'FirstName';
  static readonly SURNAME = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname';
  static readonly POSTAL_CODE = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/postalcode';
  static readonly OTHER_PHONE = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/otherphone';
  static readonly PERMISSION = 'Permission';
  static readonly VEHICLE_PERMISSION = 'VehiclePermission';
  static readonly VEHICLE_IDENTIFICATION_NUMBER = 'Vehicle';
  static readonly TERMS_AND_CONDITIONS_ACCEPTED = 'TermsAndConditionsAccepted';
  static readonly DEALER_ACCOUNT = 'DealerAccount';
  static readonly DEALER_PERMISSION = 'DealerPermission';
  static readonly DEALER_ROLE = 'DealerRole';
}

export class Permissions {
  static readonly ManageAllUsers = 'Manage All Users';
  static readonly ManageRoles = 'Manage Roles';
  static readonly ManageEmails = 'Manage Emails';
  static readonly InviteConsumerUser = 'Invite Consumer User';
  static readonly VehicleReadAccess = 'Vehicle Read Access';
  static readonly VehicleWriteAccess = 'Vehicle Write Access';
  static readonly ManageDealerAdmin = 'Manage Dealer Admin';
  static readonly ManageDealerUsers = 'Manage Dealer Users';
  static readonly ViewDealerUsers = 'View Dealer Users';
}

export class DealerRoles {
  static readonly DealerAdmin = 'Dealer Admin';
  static readonly DealerSuperAdmin = 'Dealer Super Admin';
  static readonly DealerWarranty = 'Dealer Warranty';
  static readonly DealerFinance = 'Dealer Finance';
  static readonly DealerSales = 'Dealer Sales';
  static readonly AdminAssistant = 'ADMIN ASSISTANT';
}
